import React, {useState, useEffect, useRef} from 'react';
import Toolbar from './Toolbar';
import SidePanel from './SidePanel';
import DesignerStage from './DesignerStage';
import LayerPanel from './LayerPanel';
import useDesignerStore from './designerStore';
import { useConfirmExit } from '../../hooks/useConfirmExit';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { getAllCards,
        getCardById,
        createCard,
        updateCard,
        deleteCard } from './cardService';
import { useOrg, loading } from "../orgs/org-context";

// const containerWidth = 1000;
// const containerHeight = 700-60;
export const SIDE_PANEL_WIDTH = 251;
export const LAYERS_PANEL_WIDTH = 190;
export const MENU_PANEL_WIDTH = 176;

const CanvasDesigner = ({ isSidebarOpen }) => {
  const { id } = useParams();
  // const loadCard = useDesignerStore(state => state.loadCard);
  // const resetCard = useDesignerStore(state => state.resetCard); // optional if you add it
  const [loading, setLoading] = useState(true);
  // const isDirty = useDesignerStore(s => s.isDirty);

  const {
    loadCard,
    resetCard,
    isDirty
  } = useDesignerStore();

  const { activeOrg, switchOrg} = useOrg();
  const navigate = useNavigate();
  const prevOrgRef = useRef(activeOrg);

  const confirmExit = useConfirmExit({
    isDirty,
    onConfirm: () => {
      resetCard();
      navigate('/cards');
    },
    toastMessage: 'Unsaved card changes',
    confirmMessage: 'Leave card editor and discard changes?'
  });


  useEffect(() => {
    // first render
    if (!prevOrgRef.current) {
      prevOrgRef.current = activeOrg;
      return;
    }

    // org changed
    if (activeOrg !== prevOrgRef.current) {
      confirmExit().then(allowed => {
        if (allowed) {
          // LEAVE: accept new org
          prevOrgRef.current = activeOrg;
        } else {
          // STAY: rollback org immediately
          switchOrg(prevOrgRef.current._id);
        }
      });
    }
  }, [activeOrg]);


  useEffect(() => {
    const handler = (e) => {
      if (!isDirty) return;

      e.preventDefault();
      e.returnValue = '';
    };

    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [isDirty]);


  useEffect(() => {
    let a;

    const fetchCard = async () => {
      resetCard(); // ✅ Always start clean

      if (id && id !== "0" && id !== "add") {
        try {
          var card = await getCardById(id);

          loadCard(card);


        } catch (error) {
          console.error("Error loading card:", error);
        }
      } else {
        // New card (id === "0" or no id)
        loadCard({
          cardId: null,
          prospectiveCaptureInputs: true,
          orgId: '',
          datasetId: '',
          name: '',
          description: '',
          cardSettings: {
            size: 'cr80',
            format: 'landscape',
            sides: 'Simplex',
            silverFront: 'no',
            silverBack: 'no',
          },
          objectsFront: [],
          objectsFrontSilver: [],
          objectsBack: [],
          objectsBackSilver: [],
        });

      }
      setLoading(false);
    };

    fetchCard();
  }, [id]);



  if (loading || !activeOrg) {
    return <div>Loading organization…</div>;
  }


    return (
      <div >
        {/* Top Toolbar Row */}
        <Toolbar />

        {/* Main Canvas and Side Panels */}
        <div className="canvas-layout">
          <SidePanel />
          <DesignerStage isMenuOpen={isSidebarOpen} />
          <LayerPanel />
        </div>
      </div>
    );
  };

export default CanvasDesigner;
